import {Component} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GeneralListComponent} from '../../general/list/generalList.component';
import {MessageService} from '../../../../shared/message.service';
import {AutomationMappingService} from '../../../services/automation-mapping.service';
import {AutomationMapping} from '../../../interfaces/automationMapping';

@Component({
  selector: 'app-automationmappings',
  templateUrl: '../../general/list/generalList.component.html',
  styleUrls: ['../../general/list/generalList.component.css']
})
export class AutomationMappingListComponent extends GeneralListComponent<AutomationMapping> {

  constructor(
    service: AutomationMappingService,
    router: Router,
    messagesService: MessageService,
    modalService: NgbModal,
    route: ActivatedRoute) {
    super(
      service,
      router,
      messagesService,
      route,
      modalService,
      {
        entityNameSingular: 'automationmapping',
        entityNamePlural: 'automationmappings',
        formUrl: 'automationmapping',
        listUrl: 'automationmappings',
        generalFormMetaName: 'automation-mapping',
      },
    );
  }
}
